/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Create_First_TopicInputs */

const en_create_first_topic = /** @type {(inputs: Create_First_TopicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create your first topic to start the conversation.`)
};

const es_create_first_topic = /** @type {(inputs: Create_First_TopicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea tu primer tema para iniciar la conversación.`)
};

const fr_create_first_topic = /** @type {(inputs: Create_First_TopicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créez votre premier sujet pour démarrer la conversation.`)
};

const de_create_first_topic = /** @type {(inputs: Create_First_TopicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstelle dein erstes Thema, um die Unterhaltung zu beginnen.`)
};

const id_create_first_topic = /** @type {(inputs: Create_First_TopicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buat topik pertama Anda untuk memulai percakapan.`)
};

/** @type {(inputs: Create_First_TopicInputs) => LocalizedString} */
const ja_create_first_topic = en_create_first_topic;

/** @type {(inputs: Create_First_TopicInputs) => LocalizedString} */
const zh_create_first_topic = en_create_first_topic;

/** @type {(inputs: Create_First_TopicInputs) => LocalizedString} */
const ar_create_first_topic = en_create_first_topic;

/** @type {(inputs: Create_First_TopicInputs) => LocalizedString} */
const it_create_first_topic = en_create_first_topic;

/** @type {(inputs: Create_First_TopicInputs) => LocalizedString} */
const ru_create_first_topic = en_create_first_topic;

/** @type {(inputs: Create_First_TopicInputs) => LocalizedString} */
const pt_create_first_topic = en_create_first_topic;

/** @type {(inputs: Create_First_TopicInputs) => LocalizedString} */
const ko_create_first_topic = en_create_first_topic;

/**
* | output |
* | --- |
* | "Create your first topic to start the conversation." |
*
* @param {Create_First_TopicInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const create_first_topic = /** @type {((inputs?: Create_First_TopicInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Create_First_TopicInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_create_first_topic(inputs)
	if (locale === "es") return es_create_first_topic(inputs)
	if (locale === "fr") return fr_create_first_topic(inputs)
	if (locale === "de") return de_create_first_topic(inputs)
	if (locale === "ja") return ja_create_first_topic(inputs)
	if (locale === "zh") return zh_create_first_topic(inputs)
	if (locale === "ar") return ar_create_first_topic(inputs)
	if (locale === "id") return id_create_first_topic(inputs)
	if (locale === "it") return it_create_first_topic(inputs)
	if (locale === "ru") return ru_create_first_topic(inputs)
	if (locale === "pt") return pt_create_first_topic(inputs)
	return ko_create_first_topic(inputs)
});